<template>
    <v-container fluid fill-height>
        <v-layout column fill-height align-center justify-center>
            <v-flex xs2>
                <h1 class="display-4">NB-Archiver</h1>
        
            </v-flex>
            
        </v-layout>
        
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
export default { 

    
        

    

}
    
</script>

